import React from "react";
import { motion } from "framer-motion";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { TrendingUpIconWrapper } from "./styles";

export interface KLTrendingUpIconProps {
  /**
   * Size of the icon
   */
  size?: "small" | "medium" | "large";
  /**
   * Enable tap feedback animation (mobile-first)
   */
  animated?: boolean;
  /**
   * Add glow effect (recommended for large insight icons)
   */
  withGlow?: boolean;
  /**
   * Use custom gradient styling
   */
  customStyle?: boolean;
}

const KLTrendingUpIcon: React.FC<KLTrendingUpIconProps> = ({
  size = "medium",
  animated = false,
  withGlow = true,
  customStyle = true,
}) => {
  const Component = animated ? motion.div : "div";

  return (
    <TrendingUpIconWrapper
      as={Component}
      $size={size}
      $withGlow={withGlow && customStyle && size !== "small"}
      $customStyle={customStyle}
      role="img"
      aria-label="תובנות וניתוחים"
      {...(animated
        ? {
            whileTap: { scale: 0.95 },
            transition: { type: "spring", stiffness: 300, damping: 20 },
          }
        : {})}
    >
      <TrendingUpIcon />
    </TrendingUpIconWrapper>
  );
};

export default KLTrendingUpIcon;
